import { TaxReportForm } from "@/constants/TaxReportForm";

export enum TaxObligationLiabilityType {
    FORM_941_MEDICARE = 'FORM_941_MEDICARE',
    FORM_941_SST = 'FORM_941_SST',
    FORM_941_FIT = 'FORM_941_FIT',
    FORM_940_FUT = 'FORM_940_FUT',
    FORM_1120_FEDERAL_TAX = 'FORM_1120_FEDERAL_TAX',
    FORM_1120_STATE_TAX = 'FORM_1120_STATE_TAX',
    FORM_1120_CITY_TAX = 'FORM_1120_CITY_TAX',
    FORM_1120S_STATE_FRANCHISE_TAX = 'FORM_1120S_STATE_FRANCHISE_TAX',
    FORM_1065_STATE_TAX = 'FORM_1065_STATE_TAX',
    SALES_TAX = 'SALES_TAX',
    USE_TAX = 'USE_TAX',
    ANNUAL_REPORT_STATE_FEE = 'ANNUAL_REPORT_STATE_FEE',
}

export function getTaxObligationLiabilityTypeLabel(type: TaxObligationLiabilityType): string {
    switch (type) {
        case TaxObligationLiabilityType.FORM_941_MEDICARE: return "Form 941 Medicare";
        case TaxObligationLiabilityType.FORM_941_SST: return "Form 941 Social Security Tax";
        case TaxObligationLiabilityType.FORM_941_FIT: return "Form 941 Federal Income Tax";
        case TaxObligationLiabilityType.FORM_940_FUT: return "Form 940 Federal Unemployment Tax";
        case TaxObligationLiabilityType.FORM_1120_FEDERAL_TAX: return "Form 1120 Federal Tax";
        case TaxObligationLiabilityType.FORM_1120_STATE_TAX: return "Form 1120 State Tax";
        case TaxObligationLiabilityType.FORM_1120_CITY_TAX: return "Form 1120 City Tax";
        case TaxObligationLiabilityType.FORM_1120S_STATE_FRANCHISE_TAX: return "Form 1120S State Franchise Tax";
        case TaxObligationLiabilityType.FORM_1065_STATE_TAX: return "Form 1065 State Tax";
        case TaxObligationLiabilityType.SALES_TAX: return "Sales Tax";
        case TaxObligationLiabilityType.USE_TAX: return "Use Tax";
        case TaxObligationLiabilityType.ANNUAL_REPORT_STATE_FEE: return "Annual Report State Fee";
        default: return type;
    }
}

export const TaxObligationLiabilityMapping: Record<TaxReportForm, TaxObligationLiabilityType[]> = {
    [TaxReportForm.FORM_941]: [
        TaxObligationLiabilityType.FORM_941_MEDICARE,
        TaxObligationLiabilityType.FORM_941_SST,
        TaxObligationLiabilityType.FORM_941_FIT,
    ],
    [TaxReportForm.FORM_940]: [
        TaxObligationLiabilityType.FORM_940_FUT,
    ],
    [TaxReportForm.FORM_1120]: [
        TaxObligationLiabilityType.FORM_1120_FEDERAL_TAX,
        TaxObligationLiabilityType.FORM_1120_STATE_TAX,
        TaxObligationLiabilityType.FORM_1120_CITY_TAX,
    ],
    [TaxReportForm.FORM_1120S]: [
        TaxObligationLiabilityType.FORM_1120S_STATE_FRANCHISE_TAX,
    ],
    [TaxReportForm.FORM_1065]: [
        TaxObligationLiabilityType.FORM_1065_STATE_TAX,
    ],
    [TaxReportForm.SALES_TAX_REPORT]: [
        TaxObligationLiabilityType.SALES_TAX,
        TaxObligationLiabilityType.USE_TAX,
    ],
    [TaxReportForm.ANNUAL_REPORT]: [
        TaxObligationLiabilityType.ANNUAL_REPORT_STATE_FEE,
    ],
};

/**
 * Возвращает список обязательств, которые должны быть предзаполнены по умолчанию для конкретной формы.
 */
export function getDefaultLiabilitiesForForm(form: TaxReportForm): TaxObligationLiabilityType[] {
    switch (form) {
        case TaxReportForm.FORM_941:
            // Добавляем все допустимые типы
            return TaxObligationLiabilityMapping[TaxReportForm.FORM_941];

        case TaxReportForm.FORM_940:
        case TaxReportForm.FORM_1120S:
        case TaxReportForm.FORM_1065:
        case TaxReportForm.ANNUAL_REPORT:
            // Добавляем единственную (первую в маппинге)
            return [TaxObligationLiabilityMapping[form][0]];

        case TaxReportForm.FORM_1120:
            // По умолчанию только FEDERAL_TAX
            return [TaxObligationLiabilityType.FORM_1120_FEDERAL_TAX];

        case TaxReportForm.SALES_TAX_REPORT:
            // Добавляем SALES_TAX (USE_TAX остается опциональным)
            return [TaxObligationLiabilityType.SALES_TAX];

        default:
            return [];
    }
}
